import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './global.less'

Vue.config.productionTip = false

const userInfo = {}

Vue.prototype.global = {
  userInfo
}

Vue.use(Antd)

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
